import React, { useState, useEffect } from 'react';
import CustomTitle from '../components/UI/title/CustomTitle';
import MyButton from '../components/UI/button/MyButton';
import { WithWizard } from 'react-albus-react18';
import axios from 'axios';
import { useHandleRedirect } from '../hooks/useHandleRedirect';
import { useDispatch, useSelector } from 'react-redux';
import useMixpanel from '../hooks/useMixpanel';
import { useSearchBusinessProfilesQuery } from '../api/dataApi';
import { setButtonBackIsShow, setButtonClick } from '../store/buttonSlice';

const Name = ({ setButtonShow, setButtonText, setButtonStatus, setSignupBottom, setSelectedOption, error, setError }) => {


    const { data: businessProfiles } = useSearchBusinessProfilesQuery(localStorage.getItem("email"));

    useEffect(() => {
        if (businessProfiles && businessProfiles.data && businessProfiles.data.code) {
            localStorage.setItem('setup-code', businessProfiles.data?.code);
        }
    }, [businessProfiles])

    const { trackEvent } = useMixpanel();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setButtonBackIsShow(false));
        trackEvent('web_name_view', {

        })
        setButtonText("Continue");
        setButtonText("Continue");
        setButtonShow(true);
        setButtonStatus("");
        setSignupBottom('');
        setSelectedOption('1')
        setError(false);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'lead'
        });
    }, []);


    const [name, setName] = useState('');

    const [noEmail, setNoEmail] = useState(false);

    const handleInputChange = (event) => {
        const newValue = event.target.value.replace(/\s+/g, ''); // Удаляем все пробелы
        setName(newValue);
        localStorage.setItem('name', newValue)

        var profilesJSON = localStorage.getItem('business-profiles');
        if (profilesJSON) {
            var profiles = JSON.parse(profilesJSON);
            profiles.forEach(function (profile) {
                profile.userName = newValue;
                profile.userPosition = "CEO";
            });
            var updatedProfilesJSON = JSON.stringify(profiles);
            localStorage.setItem('business-profiles', updatedProfilesJSON);
        } else {
            var newProfile = {
                userName: newValue,
                userPosition: "CEO"
            };
            var newProfiles = [newProfile];
            var newProfilesJSON = JSON.stringify(newProfiles);
            localStorage.setItem('business-profiles', newProfilesJSON);
        }
        if (newValue == "") {
            setSelectedOption(null)
            setButtonStatus("");
        } else {
            setSelectedOption('1')
            setButtonStatus("businessProfilesUpdate");
        }
    };


    const { handleRedirectClick } = useHandleRedirect();
    const buttonClicked = useSelector((state) => state.button.buttonClicked);




    useEffect(() => {

        if (buttonClicked) {
            if (name.length === 0) {

                setError(true);
                // setTimeout(() => {
                //   setError(false);
                // }, 1000);

                setTimeout(() => {
                    dispatch(setButtonClick(false));
                }, 100);
                return
            }

            handleRedirectClick(
                '',
                '',
                'web_name',
                {
                    web_entrance: 'signup',
                    error_reason: noEmail ? "no_email" : "none"
                }
            );
        }
    }, [buttonClicked, noEmail]);


    return (
        <div style={{ paddingBottom: "36rem" }}>
            <CustomTitle style={{ marginBottom: "24rem" }} title="Glad to have you with us! What’s your name?" />
            <div className={`input ${error ? 'error' : ''}`} >
                <input
                    type="text" placeholder='Your name'
                    value={name}
                    onChange={handleInputChange}
                    onFocus={() => {
                        trackEvent('web_name_input', {});

                    }}
                    onKeyDown={() => setError(false)}
                />

            </div>

            {error && (
                <div className="error-text">
                    Please, enter your name
                </div>
            )}
            {/* <WithWizard
                render={({ next, previous, step, steps }) => (
                    <MyButton onClick={next} buttonText={'Continue'}>

                    </MyButton >
                )}
            /> */}



        </div>
    );
}

export default Name;
